import styled from 'styled-components'
import { COLORS } from 'theme/index'
import Flex from 'components/Flex'

export const Container = styled(Flex)`
  height: 90vh;
  width: 100vw;
  background-color: #fafafb;
  gap: 40px;
`
export const Wrapper = styled.div`
  width: 48%;
  padding-top: 90px;
`

export const Salutation = styled(Flex)`
  margin-top: 15px;
  height: auto;
  gap: 10px;
`
export const Content = styled(Flex)`
  height: auto;
  width: 100%;
  background-color: white;
  border: 1px solid #e6e7ea;
  box-shadow: 0px 6px 10px rgba(86, 94, 106, 0.1);
  padding: 40px 60px 34px 60px;
  gap: 20px;
  border-radius: 10px;
`
export const Heading = styled.div`
  font-weight: 700;
  font-size: 1.4285714285714286em;
  line-height: 28px;
  color: #010e30;
`
export const Para = styled.div`
  font-weight: 400;
  font-size: 1em;
  line-height: 20px;
  color: #676e83;
`

export const Hello = styled.div`
  font-weight: 700;
  font-size: 1.2857142857142858em;
  line-height: 24px;
  color: #4d566e;
  text-transform: capitalize;
`
export const Points = styled(Flex)`
  height: auto;
  gap: 10px;
`
export const TableHeading = styled.div`
  font-size: 1em;
  line-height: 18px;
  color: #010e30;
  font-weight: 600;
`
export const Table = styled(Flex)`
  padding: 25px 19px;
  background: #ffffff;
  border: 1px solid #e6e7ea;
  border-radius: 10px;
`
export const TableSubHeading = styled.div`
  font-weight: 400;
  font-size: 1em;
  line-height: 20px;
  color: #676e83;
  margin-bottom: 15px;
`
export const TableContent = styled(Flex)`
  gap: 10px;
`

export const Icon = styled.div``

export const TableContentFlex = styled(Flex)`
  gap: 12px;
`

export const Anchor = styled.a`
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 1em;
  line-height: 18px;
  text-align: center;
  color: #ffffff;
  width: 100%;
  padding: 10px;
  background: ${COLORS.PRIMARY};
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 10px;
  width: fit-content;
  margin-top: 10px;
  &:hover {
    color: #ffffff;
    background: #3249d7;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  }
  &:focus {
    color: #ffffff;
    background: #3249d7;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  }
`
export const ParaSpan = styled.span`
  color: #b3b7c1;
  font-weight: 400;
  font-size: 14px;
  line-height: 2px;
`
export const TermSpan = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #999fac;
  margin-left: -13px;
`
export const TermsA = styled.a`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: ${COLORS.PRIMARY};
`
